module.exports = __webpack_public_path__ + "img/RenderFinalSubmission - Damonite P.72b8d665.png";